module.exports = __webpack_public_path__ + "static/media/Aeonik-Regular.f37dd71e.woff2";